

import { reconcileBillDetailState, reconcileBillDetailMutations, reconcileBillDetailActions } from './reconcileBillDetail.store'
import { commonState, commonMutations, commonActions } from './common.store'

const state = {
  ...reconcileBillDetailState,
  ...commonState,
}
const mutations = {
  ...reconcileBillDetailMutations,
  ...commonMutations,
}
const actions = {
  ...reconcileBillDetailActions,
  ...commonActions,
}
const bikeBudgetMgmt = {
  namespaced: true,
  state,
  mutations,
  actions
}
export default bikeBudgetMgmt
